"use client";
import { useState } from "react";
import clsx from "clsx";
import BadgeRoundedSquare from "../badge-rounded-square/BadgeRoundedSquare";
import Arrow from "../badge-rounded-square/icons-svg/Arrow";

type AccordionComponentProps = {
	items: {
		_key: string;
		title: string;
		description: string;
	}[];
};

export default function AccordionComponent({ items }: AccordionComponentProps) {
	const [openItem, setOpenItem] = useState<string>(items[0]._key || "");
	const [hoveredItem, setHoveredItem] = useState<string | null>(null);

	const toggleItem = (itemId: string) => {
		if (openItem !== itemId) {
			setOpenItem(itemId);
		}
	};

	return (
		<div className="flex flex-col gap-y-[0.438rem]">
			{items.map((item) => {
				const isOpen = openItem === item._key;
				const isHovered = hoveredItem === item._key;

				return (
					<div key={item._key} className="overflow-hidden rounded-lg border border-[#DCDCDC] transition-all duration-300">
						<button
							className="group flex w-full cursor-pointer items-center justify-between px-5 py-5 text-left"
							onClick={() => toggleItem(item._key)}
							onMouseEnter={() => setHoveredItem(item._key)}
							onMouseLeave={() => setHoveredItem(null)}
						>
							<span
								className={clsx(
									"text-cap-m transition-colors duration-300",
									isOpen ? "text-graphite-black" : "text-graphite-black/70",
									"group-hover:text-graphite-black",
								)}
							>
								{item.title}
							</span>

							<BadgeRoundedSquare
								icon={<Arrow className="h-4 w-4" rotation={isOpen ? -90 : 90} />}
								backgroundColor={clsx(isHovered || isOpen ? "bg-olive-green-light" : "bg-navy-blue-light")}
								iconColor={clsx(isHovered || isOpen ? "text-graphite-black" : "text-navy-blue-deep")}
								className="h-[1.875rem] w-[1.875rem] transition-all duration-300 sm:h-10 sm:w-10"
							/>
						</button>

						<div
							className={clsx(
								"overflow-hidden transition-all duration-300 ease-in-out",
								isOpen ? "h-[7.5rem] opacity-100" : "h-0 opacity-0",
							)}
						>
							<div className="h-full px-5 pb-6">
								<div className="flex h-full items-start pt-0">
									<p className="text-body-m text-graphite-black/70 line-clamp-4 sm:self-end md:self-center">
										{item.description}
									</p>
								</div>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}
